import { render, staticRenderFns } from "./VerificationMethodSelect.vue?vue&type=template&id=23a59cce&scoped=true&"
import script from "./VerificationMethodSelect.vue?vue&type=script&lang=js&"
export * from "./VerificationMethodSelect.vue?vue&type=script&lang=js&"
import style0 from "./VerificationMethodSelect.vue?vue&type=style&index=0&id=23a59cce&scoped=true&lang=css&"
import style1 from "./VerificationMethodSelect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a59cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a59cce')) {
      api.createRecord('23a59cce', component.options)
    } else {
      api.reload('23a59cce', component.options)
    }
    module.hot.accept("./VerificationMethodSelect.vue?vue&type=template&id=23a59cce&scoped=true&", function () {
      api.rerender('23a59cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/VerificationMethodSelect.vue"
export default component.exports